//
//
//
//
//
//
//

export default {
  name: 'relationFormAttr',
  props: ["showField", "relationField", 'isDetail'],
  data: function data() {
    return {
      value: ''
    };
  },
  computed: {
    relationData: function relationData() {
      return this.$store.state.generator.relationData;
    }
  },
  watch: {
    relationData: {
      handler: function handler(val) {
        if (!this.showField || !this.relationField) return;
        var obj = val[this.relationField] || {};
        this.value = obj[this.showField] ? obj[this.showField] : '';
      },
      deep: true
    }
  }
};